import Helper from "@ember/component/helper"
import _ from "lodash"

export function includes(params) {
  let string = params[0]
  let substring = params[1]
  return _.includes(string, substring)
}

export default class IncludesSubString extends Helper {
  compute = includes
}
